<template>
  <div
    v-if="message.msgType !== 'chat.delete' && message.msgType !== 'chat.undo' && message.showPt && (message.showMessage || message.showPhotoContent)"
    style="position: relative"
    :class="reactionList.length && 'mb-3'">
    <div
      v-if="isMessageAction"
      class="text-center fw-semibold font-size-12 my-1 z2-message-item-center-container">
      <div
        class="px-3 py-1 font-13 rounded-pill"
        style="display: inline-block; background-color: #eaecf2; color: #3484f0">
        <div
          v-if="isMessageActionList && formatMessage.length"
          class="d-flex">
          <div
            v-for="(text, index) in formatMessage"
            :key="index"
            :class="{ 'ms-1': text.text !== '.', 'fw-700': text.type === 'bold' }">
            {{ text.text }}
          </div>
          <div
            v-if="isActionRequestJoinGroup"
            class="fw-700">
            <!-- <span
              class="highlight-text mx-2 text-red500"
              @click="onAcceptRequestJoinGroup(0)">
              Từ chối
            </span>
            <span
              class="highlight-text"
              @click="onAcceptRequestJoinGroup(1)">
              Duyệt
            </span> -->
            <span
              class="highlight-text mx-2 fw-400"
              @click="dialogReviewPendingMems = true">
              Xem chi tiết
            </span>
          </div>
        </div>
        <div v-else>{{ getActionMessage }}</div>
        <span
          v-if="message.msgType === 'chat.todo' && ['todo.ding', 'todo.update'].includes(messageContentParse.action)"
          @click="openTodo(message, messageContentParamParse.item)"
          class="text-blue me-2 pointer">
          xem chi tiết
        </span>
      </div>
    </div>

    <div
      v-else-if="message.msgType == 'chat.ecard'"
      class="z2-message-item-center-container my-2">
      <ChatECardFriendV2
        v-if="messageContentParse.type == '3' || messageContentParse.type == '2' || (messageContentParse.type == '0' && !conversation.group)"
        :conversation="conversation"
        :thumb="messageContentParse.thumb" />
      <ChatECardGroupAuthor
        v-else-if="messageContentParse.type == '0' && conversation.group"
        :conversation="conversation"
        :content="messageContentParse"
        :href="messageContentParse.href"
        :thumb="messageContentParse.thumb" />
      <ChatBirthdayV2
        v-else-if="messageContentParse.type == '1'"
        :title="messageContentParse.title"
        :description="messageContentParse.description" />
      <ChatECardV2
        v-else
        :conversation="conversation"
        :message="message"
        :href="messageContentParse.href"
        :title="messageContentParse.title"
        :description="messageContentParse.description"
        @editTopic="$emit('editTopic', message)" />
    </div>

    <div
      v-else
      class="message-reaction-wrap"
      :class="`${message.isHighlightMessage && 'highlight-message'} ${message.checkUndoMessage && 'text-grey600 opacity-undo'}`">
      <div :class="message.id.uidFrom === '0' ? 'z2-message-item-right-container' : 'z2-message-item-left-container'">
        <div
          class="d-flex"
          style="position: relative">
          <div
            class="d-flex align-items-center pointer"
            :class="message.id.uidFrom === '0' ? 'reaction-count-right-container' : 'reaction-count-left-container'"
            :style="{ bottom: footerHidden ? '0.375rem' : '-0.625rem' }">
            <el-tooltip
              v-if="reactUserTooltip"
              effect="dark"
              placement="top">
              <div slot="content">
                {{ reactUserTooltip }}
              </div>
              <div
                v-if="reactionList.length"
                class="d-flex align-items-center pointer rounded-pill reaction-list"
                @click="showReactionListDetail">
                <img
                  v-if="reactionList.find((r) => r.content.rType === 3)"
                  src="/assets/icon/Emoji-like.svg"
                  class="me-1"
                  width="16px" />
                <img
                  v-if="reactionList.find((r) => r.content.rType === 5)"
                  src="/assets/icon/Emoji-heart.svg"
                  class="me-1"
                  width="16px" />
                <img
                  v-if="reactionList.find((r) => r.content.rType === 0)"
                  src="/assets/icon/Emoji-smile.svg"
                  class="me-1"
                  width="16px" />
                <img
                  v-if="reactionList.find((r) => r.content.rType === 32)"
                  src="/assets/icon/Emoji-oh.svg"
                  class="me-1"
                  width="16px" />
                <img
                  v-if="reactionList.find((r) => r.content.rType === 2)"
                  src="/assets/icon/Emoji-cry.svg"
                  class="me-1"
                  width="16px" />
                <img
                  v-if="reactionList.find((r) => r.content.rType === 20)"
                  src="/assets/icon/Emoji-angry.svg"
                  class="me-1"
                  width="16px" />
                <span class="font-13 text-grey600 lh-sm">
                  {{ reactionList.length }}
                </span>
              </div>
            </el-tooltip>

            <div
              v-if="reactionList.length"
              class="d-flex align-items-center justify-content-center pointer rounded-pill reaction-list ms-1"
              style="position: relative; height: 28px; width: 28px"
              @click="reactMessage(getLastReaction || reactionEmpty)">
              <img
                :src="getLastReaction ? getLastReaction.src : reactionEmpty.src"
                width="18px"
                height="18px" />
              <div
                class="align-items-center rounded-pill px-2 reaction-type-list"
                :class="message.id.uidFrom === '0' ? 'reaction-type-list-right' : 'reaction-type-list-left'">
                <img
                  v-for="rType in reactionTypeList"
                  @click.prevent.stop="reactMessage(rType)"
                  :key="rType.type"
                  :src="rType.src"
                  class="me-1"
                  width="20px" />
                <img
                  @click.prevent.stop="reactMessage(reactionRemove)"
                  :key="reactionRemove.type"
                  :src="reactionRemove.src"
                  width="20px" />
              </div>
              <!-- <div class="hearts-container">
                <div
                  v-for="(heartBatch, batchIndex) in heartBatches"
                  :key="batchIndex"
                  class="hearts-batch">
                  <div
                    v-for="(heart, heartIndex) in heartBatch"
                    :key="heartIndex"
                    class="heart"
                    :style="getHeartStyle(heart)"></div>
                </div>
              </div> -->
            </div>
            <div
              v-else
              class="align-items-center justify-content-center pointer rounded-pill reaction-list reaction-button ms-1"
              style="position: relative; height: 28px; width: 28px"
              @click="reactMessage(reactionEmpty)">
              <img
                :src="reactionEmpty.src"
                width="18px"
                height="18px" />
              <div
                class="align-items-center rounded-pill px-2 reaction-type-list"
                :class="message.id.uidFrom === '0' ? 'reaction-type-list-right' : 'reaction-type-list-left'">
                <img
                  v-for="rType in reactionTypeList.filter((r) => r.type !== -1)"
                  @click.prevent.stop="reactMessage(rType)"
                  :key="rType.type"
                  :src="rType.src"
                  class="me-1"
                  width="20px" />
              </div>
            </div>
          </div>
          <el-avatar
            v-if="message.id.uidFrom !== '0' && isGroup"
            @click.native.stop="openProfile(message)"
            :src="getMember(message.id.uidFrom != '0' ? message.id.uidFrom : conversation.accountId).avatar"
            class="pointer ms-3 mt-2"
            style="min-width: 28px; min-height: 28px; max-width: 28px; max-height: 28px" />
          <div>
            <div
              class="z2-message-item-right"
              style="position: relative"
              :class="background"
              :style="{ border: borderHidden ? 'hidden' : '', 'min-width': message.checkUndoMessage || reactionList.length && '120px' }">
              <div
                class="font-13 fw-400 px-12 pt-2"
                style="display: block; color: #9497a5"
                v-if="
                  isGroup &&
                  !message.isActionMessage &&
                  message.id.uidFrom != '0' &&
                  !(message.msgType == 'chat.recommended' && messageContentParse.action == 'recommened.user')
                ">
                {{ getName }}
              </div>

              <div
                class="rounded-1 p-2 border-answer mx-12 mt-2 pointer"
                :class="message.id.uidFrom === '0' ? 'bg-blue200' : 'bg-blue100'"
                @click="onClickMessageReplied"
                v-if="message.quoteMsg && !messageReplied">
                <div
                  v-if="
                    messageQuoteMsgParse.cliMsgType !== 32 &&
                    messageQuoteMsgParse.cliMsgType !== 37 &&
                    messageQuoteMsgParse.cliMsgType !== 49 &&
                    messageQuoteMsgParse.cliMsgType !== 46
                  "
                  class="fw-semibold font-size-14 my-1">
                  {{ messageQuoteMsgParse.fromD }}
                </div>

                <ChatText
                  v-if="messageQuoteMsgParse.cliMsgType == 1"
                  @clickLinkGroup="onClickLinkGroup"
                  :mentions="mentionsQuote"
                  :content="messageQuoteMsgParse.msg"
                  :keyHighlight="message.keyHighlight" />

                <div
                  class="d-flex"
                  v-if="messageQuoteMsgParse.cliMsgType == 46">
                  <el-image
                    :src="fileTypeIcon(messageQuoteMsgAttachParamParse.fileExt)"
                    class="mt-1"
                    style="max-width: 40px; max-height: 40px; min-width: 40px; min-height: 40px" />
                  <div class="mx-2 d-flex flex-column justify-content-around">
                    <div class="fw-semibold font-13">{{ messageQuoteMsgParse.fromD }}</div>
                    <div class="text-blue500 font-14 d-flex">
                      <span>[Tệp tin]</span>
                      <span
                        class="text-grey600 ms-1 trim-text-1-line"
                        style="max-width: 200px">
                        {{ messageQuoteMsgAttachParse.title }}
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  v-if="messageQuoteMsgParse.cliMsgType == 32 || messageQuoteMsgParse.cliMsgType == 37 || messageQuoteMsgParse.cliMsgType == 49"
                  class="d-flex">
                  <ChatPhotoV2
                    :href="getHrefQuoteMsg"
                    :quote="true" />
                  <div class="mx-2 d-flex flex-column justify-content-around">
                    <div class="fw-semibold font-13">{{ messageQuoteMsgParse.fromD }}</div>
                    <div class="text-blue500 font-14">[Hình ảnh]</div>
                  </div>
                </div>

                <ChatRecommendedV2
                  v-if="messageQuoteMsgParse.cliMsgType == 38"
                  :title="messageQuoteMsgAttachParse.title"
                  :thumb="messageQuoteMsgAttachParse.thumb"
                  :phone="getPhone"
                  :qrCodeUrl="getQrCode" />

                <ChatLocation
                  v-if="messageQuoteMsgParse.cliMsgType == 43"
                  :description="messageQuoteMsgAttachParse.desc"
                  :latitude="messageQuoteMsgAttachParse.lat"
                  :longitude="messageQuoteMsgAttachParse.lo" />

                <ChatVideo
                  v-if="messageQuoteMsgParse.cliMsgType == 44"
                  :href="messageQuoteMsgAttachParse.href"
                  :thumb="messageQuoteMsgAttachParse.thumbUrl" />

                <ChatVoiceV2
                  :src="messageQuoteMsgAttachParse.href"
                  v-if="messageQuoteMsgParse.cliMsgType == 31" />

                <ChatStickerV2
                  v-if="messageQuoteMsgParse.cliMsgType == 36"
                  :id="messageQuoteMsgAttachParse.id" />
              </div>

              <div v-if="message.msgType === 'LOADING_FILE'">
                <FileLoading :file="message" />
              </div>

              <div
                class="z2-message-item-right-content"
                v-if="message.msgType === 'webchat'">
                <ChatText
                  @clickLinkGroup="onClickLinkGroup"
                  :keyHighlight="message.keyHighlight"
                  :mentions="message.mentions"
                  :messageRepied="messageReplied"
                  :content="message.content" />
              </div>
              <div v-if="message.msgType == 'chat.recommended'">
                <ChatCallV2
                  v-if="messageContentParse.action === 'recommened.calltime'"
                  :messageRepied="messageReplied"
                  :duration="messageContentParamParse.duration"
                  :message="message" />
                <ChatRecommendedV2
                  v-if="messageContentParse.action == 'recommened.use'"
                  class="py-2"
                  :messageRepied="messageReplied"
                  :thumb="messageContentParse.thumb"
                  :title="messageContentParse.title"
                  :phone="messageContentDescriptionParse.phone"
                  :qrCodeUrl="messageContentDescriptionParse.qrCodeUrl" />
                <ChatBusinessCardV2
                  v-if="messageContentParse.action == 'recommened.user'"
                  :message="message"
                  :account-id="accountId"
                  :messageRepied="messageReplied" />

                <div
                  v-if="messageContentParse.action == 'recommened.link'"
                  class="py-2"
                  style="max-width: 40vw">
                  <ChatText
                    v-if="messageReplied"
                    @clickLinkGroup="onClickLinkGroup"
                    :keyHighlight="message.keyHighlight"
                    :mentions="message.mentions"
                    :messageRepied="messageReplied"
                    :content="messageContentParse.title" />
                  <div
                    v-else
                    style="max-width: 400px">
                    <div class="px-12">
                      <ChatText
                        v-if="messageContentParse.title"
                        @clickLinkGroup="onClickLinkGroup"
                        :mentions="message.mentions"
                        :content="messageContentParse.title"
                        :keyHighlight="message.keyHighlight" />
                    </div>

                    <a
                      :href="messageContentParse.href"
                      target="_blank"
                      v-bind:class="[ERROR_LINK, ''].includes(thumbContent) && 'd-flex px-12 pointer'">
                      <el-image
                        class="mt-2 mx-12 rounded-1"
                        v-if="thumbContent"
                        :src="!thumbContent ? ERROR_LINK : thumbContent"
                        fit="cover"
                        v-bind:style="
                          [ERROR_LINK, ''].includes(thumbContent)
                            ? 'min-height:70px;min-width:70px;max-height:70px;max-width:70px;margin:10px 10px 10px 0px'
                            : ''
                        "></el-image>
                      <div
                        class="px-12"
                        v-bind:class="[ERROR_LINK, ''].includes(thumbContent) ? 'd-flex flex-column mt-2' : ''">
                        <div v-if="messageContentParse.params && messageContentParamParse.mediaTitle">
                          <ChatText
                            @clickLinkGroup="onClickLinkGroup"
                            :mentions="message.mentions"
                            :content="messageContentParamParse.mediaTitle"
                            :keyHighlight="message.keyHighlight"
                            class="fw-semibold" />
                        </div>
                        <div
                          v-if="messageContentParse.description && ![ERROR_LINK, ''].includes(thumbContent)"
                          style="color: #7589a3; word-break: break-word; max-width: 40vw">
                          {{ messageContentParse.description }}
                        </div>
                        <a
                          :href="'https://' + messageContentParamParse.src"
                          target="_blank"
                          class="text-decoration-none font-size-12 mt-2 fw-semibold">
                          {{ messageContentParamParse.src }}
                        </a>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  v-if="messageContentParse.action == 'recommened.misscall'"
                  class="px-12 py-2">
                  <div
                    class="text-error fw-semibold"
                    :class="message.checkUndoMessage && 'text-grey600'">
                    <img src="/assets/icon/call-miss.svg" />
                    Cuộc gọi nhỡ
                  </div>
                </div>
              </div>
              <ChatFileV2
                v-if="message.msgType == 'share.file'"
                class="px-2 py-1"
                :messageRepied="messageReplied"
                :thumb="messageContentParse.thumb"
                :file-ext="messageContentParamParse.fileExt"
                :title="messageContentParse.title"
                :file-size="messageContentParamParse.fileSize"
                :href="getCloudUrl(messageContentParse.href, message)"
                :account-id="accountId"
                :message-id="message.id"
                :message-ts="message.ts" />

              <ChatLocationV2
                v-if="message.msgType == 'chat.location.new'"
                :messageRepied="messageReplied"
                :description="messageContentParse.description"
                :latitude="messageContentParamParse.latitude"
                :longitude="messageContentParamParse.longitude" />

              <ChatVideo
                v-if="message.msgType == 'chat.video.msg'"
                :messageRepied="messageReplied"
                :href="getCloudUrl(messageContentParse.href, message)"
                :thumb="messageContentParse.thumb"
                :title="messageContentParse.title" />

              <ChatPollV2
                v-if="message.msgType == 'group.poll'"
                :conversationId="conversation.id"
                :account-id="accountId"
                :content="JSON.parse(message.content)" />
              <ChatStickerV2
                v-if="message.msgType == 'chat.sticker'"
                :messageRepied="messageReplied"
                :id="messageContentParse.id" />
              <ChatVoiceV2
                v-if="message.msgType == 'chat.voice'"
                :messageRepied="messageReplied"
                :src="messageContentParamParse.m4a" />
              <ChatGifV2
                v-if="message.msgType == 'chat.gif'"
                :message-id="message.id"
                :account-id="accountId"
                :messageRepied="messageReplied"
                :href="getCloudUrl(messageContentParse.href, message)"
                :thumb="messageContentParse.thumb"
                title="">
                {{ messageContentParse.href }}
              </ChatGifV2>

              <ChatTodoV2
                v-if="message.msgType === 'chat.todo' && messageContentParse.action === 'todo.create'"
                :account-id="accountId"
                :members="members"
                :message="message" />
              <ChatPhotoV2
                v-if="message.showPhotoContent"
                :messageRepied="messageReplied"
                :message="message"
                :message-list="messageList"
                :href="getCloudUrl(messageContentParse.href, message)"
                :title="messageContentParse.title"
                :group-layout-id="message.groupLayoutId" />
              <ChatPhotoV2
                v-if="message.msgType == 'chat.doodle'"
                :messageRepied="messageReplied"
                :href="messageContentParse.href"
                title="" />

              <el-divider v-if="!borderHidden && !footerHidden" />
              <div
                v-if="!footerHidden"
                :class="{
                  'pt-0': borderHidden,
                  'z2-message-item-right-footer': message.id.uidFrom === '0',
                  'z2-message-item-left-footer': message.id.uidFrom !== '0',
                }">
                <span
                  v-if="message.id.uidFrom === '0'"
                  class="me-2">
                  {{ sendBy }}
                </span>
                <div class="d-flex align-items-center">
                  <el-tooltip
                    :content="timestampToDatetime"
                    placement="top">
                    <span v-if="!message.checkUndoMessage">{{ timestamp }}</span>
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    content="Đã ghim"
                    placement="top">
                    <div class="ms-1 pointer">
                      <IconV2
                        v-if="isPinMsg"
                        name="v2-mark"
                        color="#3484F0" />
                    </div>
                  </el-tooltip>
                </div>
              </div>

              <MessageActionV2
                :class="message.id.uidFrom === '0' ? 'z2-message-action-right' : 'z2-message-action-left'"
                :message="message"
                :isPinMsg="isPinMsg"
                @showRepliedMessage="$emit('showRepliedMessage', message)"
                @showMessageSharePopup="$emit('showMessageSharePopup', message)"
                @copy="$emit('copy', message)"
                @downloadImage="$emit('downloadImage', message)"
                @undoMessage="$emit('undoMessage', message)"
                @deleteMessage="$emit('deleteMessage', message)"
                @pinMessage="$emit('pinMessage', message)"
                @unPinMessage="$emit('unPinMessage', isPinMsg)" />
            </div>
            <div
              v-if="footerHidden"
              :class="{
                'z2-message-item-right-footer': message.id.uidFrom === '0',
                'z2-message-item-left-footer': message.id.uidFrom !== '0',
              }"
              style="margin-top: -0.75rem">
              <span
                v-if="message.id.uidFrom === '0'"
                class="me-2">
                {{ sendBy }}
              </span>
              <div>
                <el-tooltip
                  :content="timestampToDatetime"
                  placement="top">
                  <span v-if="!message.checkUndoMessage">{{ timestamp }}</span>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="Đã ghim"
                  placement="top">
                  <div class="ms-1 pointer">
                    <IconV2
                      v-if="isPinMsg"
                      name="v2-mark"
                      color="#3484F0" />
                  </div>
                </el-tooltip>
              </div>
            </div>
            <div
              v-if="message.checkUndoMessage"
              class="d-flex align-items-center justify-content-between ms-3 me-3 mb-2">
              <span
                class="me-2"
                style="color: #cf4547 !important">
                {{ message.checkDeleteMessage ? "Đã xóa" : "Đã thu hồi" }}
              </span>
              <el-tooltip
                :content="timestampToDatetime"
                placement="top">
                <span class="">{{ timestamp }}</span>
              </el-tooltip>
              <!-- <img
              class="me-1"
              src="/assets/icon/icon-undo-v2.svg" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <DialogReviewPendingMems
      v-if="dialogReviewPendingMems"
      :conversation="conversation"
      @close="dialogReviewPendingMems = false" />
  </div>
</template>

<script>
import IconV2 from "./common/IconV2";
import ChatCallV2 from "./message/ChatCallV2";
import ChatRecommendedV2 from "./message//ChatRecommendedV2";
import ChatBusinessCardV2 from "./message//ChatBusinessCardV2";
import ChatText from "./message/ChatText";
import ChatFileV2 from "./message/ChatFileV2";
import ChatLocationV2 from "./message/ChatLocationV2";
import ChatStickerV2 from "./message/ChatStickerV2";
import ChatVoiceV2 from "./message/ChatVoiceV2";
import ChatGifV2 from "./message/ChatGifV2";
import ChatTodoV2 from "./message/ChatTodoV2";
import ChatECardV2 from "./message/ChatECardV2";
import ChatBirthdayV2 from "./message/ChatBirthdayV2";
import ChatECardFriendV2 from "./message/ChatECardFriendV2";
import ChatECardGroupAuthor from "./message/ChatECardGroupAuthor";
import ChatPhotoV2 from "./message/ChatPhotoV2";
import ChatPollV2 from "./message/ChatPollV2";
import FileLoading from "./message/FileLoading";
import ChatVideo from "./message/ChatVideo";
import MessageActionV2 from "../components/MessageActionV2";
import DialogReviewPendingMems from "./message/DialogReviewPendingMems.vue";
import moment from "moment";

export default {
  props: ["message", "messageReplied", "accountId", "members", "messageList", "isGroup", "replaceUrl", "sendByList", "conversation", "pinMessages"],
  components: {
    IconV2,
    ChatCallV2,
    ChatRecommendedV2,
    ChatBusinessCardV2,
    ChatText,
    ChatFileV2,
    ChatLocationV2,
    ChatStickerV2,
    ChatVoiceV2,
    ChatGifV2,
    ChatTodoV2,
    ChatECardV2,
    ChatBirthdayV2,
    ChatPollV2,
    ChatECardFriendV2,
    ChatPhotoV2,
    ChatVideo,
    FileLoading,
    MessageActionV2,
    ChatECardGroupAuthor,
    DialogReviewPendingMems,
  },
  data() {
    return {
      formatMessage: [],
      conversationMember: {},
      hearts: [],
      heartBatches: [],
      dialogReviewPendingMems: false,
    };
  },
  computed: {
    isPinMsg() {
      return this.pinMessages.find((mess) => mess.client_msg_id == this.message.cliMsgId);
    },
    background() {
      if (this.message.msgType === "chat.sticker") {
        return "bg-transparent";
      }
      if (this.message.id.uidFrom !== "0") {
        return "bg-white";
      }
      // if (this.messageContentParse.action == "recommened.user") {
      //   return "bg-transparent";
      // }
      return "";
    },
    borderHidden() {
      return !(this.message.quoteMsg && !this.messageReplied);
    },
    footerHidden() {
      return (
        this.message.msgType == "chat.location.new" ||
        this.message.msgType == "chat.sticker" ||
        this.messageContentParse.action == "recommened.user" ||
        this.message.msgType == "chat.voice" ||
        this.messageContentParse.action === "recommened.calltime"
      );
    },
    ERROR_LINK() {
      return "https://photo-link-talk.zadn.vn/photolinkv2/720/aHR0cHM6Ly9yZXMtemFsby56YWRuLnZuL3VwbG9hZC9tZWRpYS8yMDE5LzEwLzE1L2ZlZWRfdGh1bWJfbGlua19fMV9fMTU3MTEzMzEyMjc3OF85Mzc4MC5wbmc=";
    },
    sendBy() {
      return this.message.sendBy;
    },
    reactionList() {
      return this.message.reactions || [];
    },
    timestamp() {
      const date = new Date(Number(this.message.ts));
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const formattedHours = hours < 10 ? "0" + hours : hours;
      const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      return formattedHours + ":" + formattedMinutes;
    },
    timestampToDatetime() {
      return moment(Number(this.message.ts)).format("DD/MM/YYYY HH:mm");
    },
    getHrefQuoteMsg() {
      const messageSource = this.messageList.find(mes => mes.cliMsgId == this.messageQuoteMsgParse.cliMsgId);
      if (messageSource) {
        let messageSourceContent;
        try {
          messageSourceContent = JSON.parse(messageSource.content);
        } catch (e) {
          messageSourceContent = messageSource.content;
        }
        return this.getCloudUrl(messageSourceContent.href, messageSource);
      } else {
        return this.messageQuoteMsgAttachParse.href;
      }
    },
    messageQuoteMsgParse() {
      return JSON.parse(this.message.quoteMsg);
    },
    messageQuoteMsgAttachParse() {
      return JSON.parse(JSON.parse(this.message.quoteMsg).attach);
    },
    messageQuoteMsgAttachParamParse() {
      return JSON.parse(JSON.parse(JSON.parse(this.message.quoteMsg).attach).params);
    },
    mentionsQuote() {
      try {
        let item = JSON.stringify(JSON.parse(JSON.parse(this.message.quoteMsg).attach).mentions);
        return item;
      } catch (e) {
        return "";
      }
    },
    messageContentParse() {
      try {
        return JSON.parse(this.message.content);
      } catch (e) {
        return this.message.content;
      }
    },
    messageContentParamParse() {
      return JSON.parse(this.messageContentParse.params);
    },
    messageContentDescriptionParse() {
      return JSON.parse(this.messageContentParse.description);
    },
    thumbContent() {
      return this.messageContentParse.thumb;
    },
    isMessageAction() {
      try {
        let con = JSON.parse(this.message.content);
        return ["msginfo.actionlist"].includes(con.action) || ["todo.update", "todo.ding", "todo.delete", "todo.ding_ack"].includes(con.action);
      } catch (e) {
        return false;
      }
    },
    isMessageActionList() {
      try {
        const messageContentParse = JSON.parse(this.message.content);
        return messageContentParse.action === "msginfo.actionlist";
      } catch (e) {
        return false;
      }
    },
    isActionRequestJoinGroup() {
      try {
        const messageContentParse = JSON.parse(this.message.content);
        const modifiedJsonString = messageContentParse.params.replace(/"uid":(\d{16,})/g, '"uid":"$1"');
        const messageContentParams = JSON.parse(modifiedJsonString);
        if (messageContentParams.actions && messageContentParams.actions.length) {
          const action = messageContentParams.actions.find((a) => a.actionType === "action.open.request.joingroup");
          return action ? true : false
          // if (!action) return false;

          // const memberRequest = messageContentParams?.simpleInfos[0]?.uid.toString();
          // const existMem = this.members.find((m) => m.id === memberRequest);
          // return existMem ? false : true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    },
    getActionMessage() {
      let action = JSON.parse(this.message.content).action;
      if (["todo.update", "todo.ding", "todo.delete"].includes(action)) {
        return "" + this.getNameTodo + this.getContentAction(this.message.content, this.accountId) + "";

        // return this.getTitleTodoName(this.message);
        // return this.getNameTodo() + this.getContentAction(this.message.content, this.accountId);
      } else if ("todo.ding_ack" === action) {
        return "Người dùng đã nhận nhắc nhở từ bạn: " + JSON.parse(JSON.parse(this.message.content).params).item.description;
      } else {
        return JSON.parse(this.message.content).title;
      }
    },
    getNameTodo() {
      let params = JSON.parse(this.messageContentParse.params);
      if (params.item.extra.isGroup) {
        let item = this.members.find((s) => s.id === params.editor);
        if (item) {
          return item.name;
        }
        return "";
      } else {
        if (this.accountId === params.editor) {
          return this.app.accounts.find((s) => s.accountId === this.accountId).displayName;
        }
        return this.app.selectedConversation.toName;
      }
    },
    getPhone() {
      try {
        return JSON.parse(JSON.parse(this.message.content).description).phone;
      } catch (e) {
        return null;
      }
    },
    getQrCode() {
      try {
        return JSON.parse(JSON.parse(JSON.parse(this.message.quoteMsg).attach).description).qrCodeUrl;
      } catch (e) {
        return null;
      }
    },
    getName() {
      let id = this.message.id.uidFrom != "0" ? this.message.id.uidFrom : this.conversation.id.accountId;
      try {
        return this.members.find((m) => m.id == id).name;
      } catch (e) {
        return "";
      }
    },
    reactionTypeList() {
      return [
        { icon: "/-strong", type: 3, src: "/assets/icon/Emoji-like.svg" },
        { icon: "/-heart", type: 5, src: "/assets/icon/Emoji-heart.svg" },
        { icon: ":>", type: 0, src: "/assets/icon/Emoji-smile.svg" },
        { icon: ":o", type: 32, src: "/assets/icon/Emoji-oh.svg" },
        { icon: ":-((", type: 2, src: "/assets/icon/Emoji-cry.svg" },
        { icon: ":-h", type: 20, src: "/assets/icon/Emoji-angry.svg" },
      ];
    },
    reactionEmpty() {
      return { icon: "/-heart", type: 5, src: "/assets/icon/Emoji-drop-heart.svg" };
    },
    reactionRemove() {
      return { icon: "", type: -1, src: "/assets/icon/Emoji-remove-reaction.svg" };
    },
    getLastReaction() {
      const lastReact = this.reactionList.findLast((r) => r.uidFrom == "0");
      if (lastReact) {
        const type = this.reactionTypeList.find((r) => r.type === lastReact.content.rType);
        return type || this.reactionEmpty;
      }
      return null;
    },
    currentAcc() {
      const currentAcc = this.app.accounts.find((a) => a.accountId === this.conversation.accountId);
      return currentAcc;
    },
    reactUidFrom() {
      const reactUidFroms = this.reactionList.map((r) => r.uidFrom);
      const uniqueList = [...new Set(reactUidFroms)];
      return uniqueList;
    },
    reactUserTooltip() {
      return this.reactUidFrom.map((u) => this.getMemberByUidFrom(u)?.name).join(",\n");
    },
  },
  mounted() {
    if (this.isMessageActionList) {
      if (!this.messageContentParse.params) {
        return [];
      }
      let params = JSON.parse(this.messageContentParse.params);
      const template = params.msg.vi;
      const data = params.highLightsV2.map((p) => p.dpn);

      const placeholderPattern = /%(\d+)\$s/g;
      const matches = template.match(placeholderPattern);

      if (!matches) {
        return [{ text: template, type: "normal" }];
      }

      const sortedMatches = matches.sort((a, b) => {
        const indexA = parseInt(a.match(/\d+/)[0]);
        const indexB = parseInt(b.match(/\d+/)[0]);
        return indexA - indexB;
      });

      let currentIndex = 0;
      const result = [];

      for (const match of sortedMatches) {
        const index = parseInt(match.match(/\d+/)[0]) - 1;
        const textBeforeMatch = template.slice(currentIndex, template.indexOf(match));
        const text = data[index];
        const placeholderLength = match.length;

        if (textBeforeMatch) {
          result.push({ text: textBeforeMatch, type: "normal" });
        }

        result.push({ text, type: "bold" });
        currentIndex = template.indexOf(match) + placeholderLength;
      }

      const textAfterLastMatch = template.slice(currentIndex);

      if (textAfterLastMatch) {
        result.push({ text: textAfterLastMatch, type: "normal" });
      }
      this.formatMessage = result;
    }
  },
  methods: {
    onClickLinkGroup(link) {
      this.$bus.$emit("clickLinkGroup", {
        conversation: this.conversation,
        link: link,
      });
    },
    groupBy(arr, field) {
      const groups = {};
      arr.forEach((item) => {
        const value = item[field];
        if (!groups[value]) {
          groups[value] = [];
        }
        groups[value].push(item);
      });
      return Object.values(groups);
    },
    getMemberByUidFrom(uidFrom) {
      if (uidFrom == "0") {
        return {
          accountId: this.currentAcc.accountId,
          id: "0",
          name: "Bạn",
          avatar: this.currentAcc.avatar,
        };
      } else {
        if (this.conversation.group) {
          const member = this.members.find((m) => m.id == uidFrom);
          return member;
        } else {
          return {
            accountId: this.conversation.accountId,
            id: this.conversation.toId,
            name: this.conversation.toName,
            avatar: this.conversation.avatar,
          };
        }
      }
    },
    showReactionListDetail() {
      this.$emit("showReactionListDetail", this.reactionList);
    },
    dropHearts() {
      const numberOfHearts = 10;
      const newHearts = Array.from({ length: numberOfHearts }, () => ({
        translateX: `${Math.random() * 200 - 100}px`,
        scale: Math.random() * 0.5 + 0.5,
      }));
      this.heartBatches.push(newHearts);

      setTimeout(() => {
        this.heartBatches.shift();
      }, 2000);
    },
    reactMessage(reaction) {
      this.dropHearts();
      this.$http.post("/api/message/sendReaction", {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        msgType: "1",
        clientMsgId: this.message.cliMsgId,
        globalMsgId: this.message.id.msgId,
        reactionIcon: reaction.icon,
        reactionType: reaction.type,
        group: this.conversation.group,
      });
    },
    getHeartStyle(heart) {
      return {
        "--translateX": heart.translateX,
        "--translateY": heart.translateY,
        "--scale": heart.scale,
        width: `${20 * heart.scale}px`, // Đặt kích thước trái tim dựa trên scale
        height: `${20 * heart.scale}px`,
      };
    },
    openProfile(message) {
      this.$emit("showProfile", message);
    },

    getMember(id) {
      return this.members.find((m) => m.id == id) ? this.members.find((m) => m.id == id) : { avatar: "" };
    },

    onClickMessageReplied() {
      this.$emit("clickMessageReplied");
    },

    onClickLinkMessage() {
      console.log(this.messageContentParse);
    },
  },
};
</script>

<style lang="scss" scoped>
.reaction-count-right-container,
.reaction-count-left-container {
  // background-color: white;
  // border: thin solid #eaecf2;
  // padding: 0.175rem 0.5rem;
  width: fit-content;
  position: absolute;
  bottom: -0.625rem;
  z-index: 99;
}
.reaction-count-left-container {
  right: 0rem;
}
.reaction-count-right-container {
  right: 0.75rem;
}

.reaction-list {
  background-color: white;
  border: thin solid #eaecf2;
  padding: 0.175rem 0.5rem;
  width: fit-content;
}

.reaction-list:hover {
  .reaction-type-list {
    display: flex;
  }
}

.reaction-type-list {
  display: none;
  background-color: white;
  border: thin solid #eaecf2;
  padding: 0.375rem 0.5rem;
  width: fit-content;
  position: absolute;
  top: -2rem;
  z-index: 99;
}

.reaction-type-list-right {
  right: 0rem;
}

.reaction-type-list-left {
  left: -4rem;
}

.heart-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.hearts-container {
  position: fixed;
  bottom: 70px; /* Cách button 50px */
  right: 70px; /* Cách button 50px */
  pointer-events: none;
  width: 0;
  height: 0;
}

.hearts-batch {
  position: absolute;
  width: 0;
  height: 0;
}

.heart {
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: red;
  clip-path: path("M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z");
  animation: fly 1s ease-in-out forwards;
}

@keyframes fly {
  0% {
    transform: translate(0, 0) scale(0.5);
    opacity: 1;
  }
  100% {
    transform: translate(var(--translateX), var(--translateY)) scale(var(--scale));
    opacity: 0;
  }
}

.message-reaction-wrap:hover {
  .reaction-button {
    display: flex;
  }
}
.reaction-button {
  display: none;
}
.highlight-message {
  background-color: #dcdfe9;
}

.highlight-text:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
